import React from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { HashLink as Link } from "react-router-hash-link"

import EditIcon from "@material-ui/icons/Edit"
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"

import { selectCourses } from "../../redux/course/course.selectors"

import "./AdminCourses.scss"

class AdminCourses extends React.Component {
  render() {
    const { courses } = this.props

    return (
      <div className="container admin-courses">
        <div className="admin-courses-header">
          <div>
            <p className="eyebrow">Admin area</p>
            <h1>Courses</h1>
            <p>Manage the courses available on the website.</p>
          </div>

          <div className="header-actions">
            <Link className="back-link" to="/dashboard">
              <ArrowBackIcon /> Back to Admin
            </Link>

            <Link className="add-button" to="/add-course/">
              Add Course <AddCircleOutlineIcon />
            </Link>
          </div>
        </div>

        <div className="courses-list">
          {courses &&
            courses.map((course) => (
              <div key={course?._id} className="course">
                <span className="name">{course.name}</span>

                <Link className="edit-button" to={`/edit-course/${course._id}`}>
                  Edit <EditIcon />
                </Link>
              </div>
            ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  courses: selectCourses,
})

export default connect(mapStateToProps, null)(AdminCourses)
